module.exports = __webpack_public_path__ + "static/media/updates.8e011c65.mp3";